export function getNameParts(name: string) {
  const parts = name.split(" ");
  const firstName = parts[0];
  const lastName = parts[parts.length - 1];

  return { firstName, lastName };
}
